import { alphabeticalSort } from './alphabetical-sort';

const yesNoOrder = Object.freeze([ 'да', 'нет' ]);

/**
 * Функция для сортировки по алфавиту за исключением того, что варианты "Да" и "Нет"
 * всегда сортируются в начало списка.
 * @example
 * // returns ["Да", "Нет", "Есть возможность подключения"]
 * ["Нет", "Есть возможность подключения", "Да"].sort(yesNoSort)
 */
export const yesNoSort = (value1: string, value2: string) => {
    let value1Index = yesNoOrder.indexOf(value1.toLocaleLowerCase());
    let value2Index = yesNoOrder.indexOf(value2.toLocaleLowerCase());

    value1Index = value1Index === -1 ? +Infinity : value1Index;
    value2Index = value2Index === -1 ? +Infinity : value2Index;

    if (value1Index === Infinity && value2Index === Infinity) {
        return alphabeticalSort(value1, value2);
    } else {
        return value1Index - value2Index;
    }
};
